import React from 'react'
import { Provider } from 'react-redux';
import store from './Components/store'

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

//  S T Y L E S
import './App.css';

// С O M P O N E N T S

import Header from './Components/Header/Header';
import Main from './Components/Main/Main';
import Footer from './Components/Footer/Footer';
import About from './Components/page/About/About';
import Project from './Components/page/Project/Project';
import Contacts from './Components/page/Contact/Contacts';
import ScrollToTop from './Utils/ScrollToTop';
import MobileMenu from './Components/Header/Mobile/MobileMenu';
import BlogPage from './Components/page/Blog/BlogPage';

function App() {
  return (
    <div className="App">
      <Provider store={store}>
        <Router >
          <ScrollToTop />
          <Header />
          <MobileMenu />
          <Routes>
            <Route path='/' element={<Main />} />
            <Route path='/project' element={<Project />} />
            <Route path='/blog' element={<BlogPage />} />
            <Route path='/about' element={<About />} />
            <Route path='/contacts' element={<Contacts />} />
          </Routes>
          <Footer />
        </Router>
      </Provider>
    </div>
  );
}

export default App;
